<template>
  <div class="page">
    <img :src="backgroundImage" alt="Left to Survive" class="page-background" loading="lazy" />

    <div class="page-wrapper">
      <ThePageIntro />
      <ThePageWeapons />
      <ThePageButton @click="regAndDownloadClick()" />
    </div>
    <TheFooter />

    <PopupInstall :showPopup="showPopupInstallGame" @closePopup="closePopup" />
    <PopupPlatform :showPopup="showPopupPlatforms" @closePopup="closePopup" />
  </div>
</template>

<script>
import ThePageIntro from "@/components/the-page/vue/ThePageIntro.vue";
import ThePageWeapons from "@/components/the-page/vue/ThePageWeapons.vue";
import ThePageButton from "@/components/the-page/vue/ThePageButton.vue";
import TheFooter from "@static_promo_pages/common/components/footer/vue/Footer.vue";
import PopupPlatform from "@static_promo_pages/common/components/popups/vue/PopupPlatform.vue";
import PopupInstall from "@static_promo_pages/common/components/popups/vue/PopupInstall.vue";
import LoginAndDownloadMixin from "@static_promo_pages/common/mixins/mygames/LoginAndDownloadMixin";

export default {
  name: "ThePage",
  components: {
    PopupInstall,
    PopupPlatform,
    ThePageButton,
    ThePageWeapons,
    ThePageIntro,
    TheFooter,
  },
  mixins: [LoginAndDownloadMixin],
  computed: {
    backgroundImage() {
      return require("@/components/the-page/images/background.webp");
    }
  },
  methods: {
    closePopup() {
      // from LoginAndDownloadMixin mixin
      this.showPopupInstallGame = false;
      this.showPopupPlatforms = false;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../styles/the-page";
</style>
